import { atom } from 'jotai';

const RESET = Symbol("Reset signal for breadcumbs atom");
const BACK = Symbol("Go back signal for breadcumbs atom");
const shadowAtom = atom([]);
const breadcrumbsAtom = atom(
    (get) => get(shadowAtom),
    (get, set, value) => {
        if (value === RESET)
            set(shadowAtom, []);
        if (value === BACK)
            set(shadowAtom, prev => prev.slice(0, -1));

        if (!value.level || !value.to || !value.label)
            throw new Error("Define valid data for Breadcrumbs");

        const newState = get(shadowAtom).filter(item => item.level < value.level);

        set(shadowAtom, [...newState, value]);
    }
);

export { breadcrumbsAtom, RESET, BACK };
export default breadcrumbsAtom;